import Logger from 'Logger'

/**
 * 결제 팝업 호출전 추가 인증 여부
 */
export function multiFactorAuthenticate() {
  Logger.info('Trying authenticate using MFA')

  $(document).trigger('app:authenticate')

  return new Promise(function (resolve, reject) {
    $(document).one('app:authSuccess', resolve)

    $(document).one('app:authFail', function (e) {
      if (e && e.type === 'app:authFail') {
        reject(new Error('mall/authFailed'))
      } else {
        Logger.info('Error `app:authFail` :', e)
        reject(new Error('mall/authFailed/unknownReason'))
      }
    })
  })
}
